import {
  roleContentFromJson,
  signUpContentFromJson,
} from 'modules/signUp/graphql/utils'

import { LocalResolver } from '@sketch/gql-types/resolvers'

const HEADERS = {
  'x-client-name': 'cloud-frontend',
  'x-client-version': (process.env.REACT_APP_RELEASE_VERSION ||
    process.env.REACT_APP_COMMIT_HASH) as string,
  'Content-Type': 'application/json',
}

export const campaignSignUpContent: LocalResolver<'Query'>['campaignSignUpContent'] = async (
  _,
  { campaign }
) => {
  const response = await fetch(`/data/signup/campaign/${campaign}.json`, {
    headers: HEADERS,
  })

  if (response.status === 200) {
    const json = await response.json()

    return {
      __typename: 'CampaignSignUpContent',
      active: json.active ?? true,
      content: signUpContentFromJson(json),
    }
  }

  return null
}

export const roleSignUpContent: LocalResolver<'Query'>['roleSignUpContent'] = async () => {
  const response = await fetch('/data/signup/roles.json', {
    headers: HEADERS,
  })

  if (response.status === 200) {
    const json = await response.json()

    return roleContentFromJson(json)
  }

  throw new Error('Something went wrong')
}
